import { IPanel, LinkActionSchema } from "smarthub-common";

export const chatPanel: IPanel = {
  $id: "panel.chat",
  $schema: "https://ics.ai/smarthub/panel",
  group: "panels.intranet",
  description: "Chat transcript and controls",
  title: "Chat",
  shortTitle: "chat",
  icon: {
    name: "Chat",
  },
  order: 1,
  initialFocus: "chat-controls",
  navigation: "none",
  menu: {
    $id: "component.chat-menu",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-menu",
    title: "Chat menu",
    description: "Choose display settings",
    props: {
      showLauncher: false,
    },
  },
  pages: {
    $id: "component.chat-pages",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-pages",
    title: "Chat pages",
    description: "Chat pages",
    props: {
      config: {
        pages: [],
      },
    },
  },
  launcher: {
    $id: "component.chat-launcher",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-launcher",
    title: "Chat launcher",
    description: "Chat launcher",
    props: {
      enabled: false,
      config: {
        title: {
          en: "",
        },
        subtitle: {
          en: "",
        },
        sections: [],
      },
    },
  },
  splash: {
    $id: "component.chat-splash",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat splash",
    description: "Chat splash",
    template: "component.chat-splash",
    props: {
      enabled: true,
      mode: "implicit",
      cacheLocation: "session",
      version: "1.0",
      sessionKey: "customer.ai-flex-chat-tnc-acceptance",
      config: {
        html: {
          en: "<p>Hi, I’m the ICO’s Digital Assistant. I can help you with your registration queries, for example whether you need to pay and how much, and if you need to appoint a Data Protection Officer.</p><p>You won’t need to tell me any personal information.</p><p>If you use this service, the contents of your chat will be shared with services provided by Microsoft and Google, that interpret and answer your questions. To find out more, read our <b><u><a href='https://ico.org.uk/global/privacy-notice/' target='_blank'>privacy policy.</a></u></b></p>",
        },

        container: {
          margin: "0px",
          padding: "20px",
          backgroundColor: "#fff",
          textColor: "#333",
          fontSize: "18px",
        },
        buttons: {
          primaryButtonBackgroundColor: "#26557f",
          primaryButtonHoverBackgroundColor: "#333",
          primaryButtonTextColor: "white",
          primaryButtonHoverTextColor: "white",
          primaryButtonPadding: "20px",
          primaryButtonFontSize: "18px",
          secondaryButtonBackgroundColor: "white",
          secondaryButtonHoverBackgroundColor: "white",
          secondaryButtonTextColor: "black",
          secondaryButtonHoverTextColor: "black",
          secondaryButtonPadding: "20px",
          secondaryButtonFontSize: "18px",
        },
      },
    },
  },
  header: {
    $id: "component.chat-header",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat header",
    description: "Chat header",
    template: "component.chat-header",
  },
  footer: {
    $id: "component.chat-footer",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat footer",
    description: "Chat footer",
    template: "component.chat-footer",
    props: {
      actions: [
        {
          name: {
            en: "privacy",
          },
          title: "",
          shortTitle: {
            en: "Privacy Statement",
          },
          description: "",
          action: {
            $id: "",
            $schema: LinkActionSchema,
            uri: "https://ico.org.uk/global/privacy-notice/",
            target: "_self",
          },
        },
      ],
    },
  },
  templates: [
    {
      $id: "template.chat",
      $schema: "https://ics.ai/smarthub/template",
      description: "Felix chat transcript and controls",
      title: "Felix chat",
      shortTitle: "Chat",
      group: "templates.intranet",
      tabs: [
        {
          $id: "layout.chat",
          $schema: "https://ics.ai/smarthub/tab",
          description: "Felix chat transcript and controls.",
          group: "tabs.intranet",
          title: "Chat",
          shortTitle: "Chat",
          icon: {
            name: "Chat",
          },
          body: {
            grid: {
              tokens: {
                padding: "none",
              },
              rows: [
                {
                  responsive: {
                    sm: { scroll: true, stretch: true },
                  },
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.main",
                        },
                      ],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.controls",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            zones: [
              {
                id: "zone.main",
                components: [
                  {
                    $id: "component.chat-transcript",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat conversation",
                    template: "component.chat-transcript",
                  },
                ],
              },
              {
                id: "zone.controls",
                components: [
                  {
                    $id: "component.chat-controls",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat controls",
                    template: "component.chat-controls",
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  ],
};
